import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { IFile } from '@model/file';

import { apiClient } from '@services/apiClient';

import type { IApiError, IContactSupportFormMutationsResponse } from '../model/contactSupportFormMutations';

interface IFormData {
  user_name: string;
  email: string;
  text: string;
  attachments: IFile[];
}

const contactSupportFormFn = (data: IFormData) =>
  apiClient.post(`${APP_API_URL_V2}customer-dashboard-v2/contact-form/send`, data);

export const useContactSupportFormMutation = () => {
  return useMutation<IContactSupportFormMutationsResponse, AxiosError<IApiError>, IFormData>({
    mutationFn: contactSupportFormFn,
  });
};
